<form (ngSubmit)="onSubmit()" [formGroup]="form" autocomplete="off" class="form-typography-removed">
  <div>
    <div [ngSwitch]="formData && formData.layout">
      <div *ngSwitchCase="'compare-prices'">
        <open-raptor-page-covers [formData]="formData" [form]="form"></open-raptor-page-covers>
      </div>

      <div *ngSwitchCase="'hollard-car-compare-prices'">
        <open-raptor-page-hollard-car-covers [formData]="formData" [form]="form"></open-raptor-page-hollard-car-covers>
      </div>

      <div *ngSwitchCase="'axis-travel-compare-prices'">
        <open-raptor-page-axis-travel-covers [formData]="formData" [form]="form"></open-raptor-page-axis-travel-covers>
      </div>
      
      <div *ngSwitchCase="'collinson-compare-prices'">
        <open-raptor-page-collinson-covers [formData]="formData" [form]="form"></open-raptor-page-collinson-covers>
      </div>

      <div *ngSwitchCase="'offramp'">
        <open-raptor-page-offramp [formData]="formData" [form]="form"></open-raptor-page-offramp>
      </div>

      <!-- DEFAULT LAYOUT -->
      <div *ngSwitchDefault>
        <open-raptor-page-default [formData]="formData" [form]="form"></open-raptor-page-default>
      </div>
    </div>

  </div>
</form>
